import React, { useState } from 'react'

import { useSignup } from './Signup.hooks'
import Col from 'react-bootstrap/Col'
import Row from 'react-bootstrap/Row'
import Button from 'react-bootstrap/Button'
import Alert from 'react-bootstrap/Alert'
import AttendeeInfo from './AttendeeInfo'
import AttendeeDialog from './AttendeeDialog'

const StepAttendees = () => {
  const { setView, attendees, removeAttendee } = useSignup()
  const [dialog, setDialog] = useState('')
  return (
    <>
      <div className="d-flex justify-content-center">
        <Button size="md" variant="outline-primary" className="mb-4" onClick={() => setDialog('add')}>
          Teilnehmer hinzufügen
        </Button>
        <AttendeeDialog open={dialog === 'add'} onClose={() => setDialog('')} />
      </div>
      {!attendees.length && (
        <Alert variant="danger" className="mt-2">
          Deine Anmeldung muss mindestens einen Teilnehmer enthalten.
        </Alert>
      )}
      <Row className="gy-3">
        {attendees.map((attendee) => (
          <Col xs={12} key={attendee._id}>
            <AttendeeInfo attendee={attendee} onEditClick={() => setDialog(`edit-${attendee._id}`)} onDeleteClick={() => removeAttendee(attendee._id)} />
            <AttendeeDialog
              open={dialog === `edit-${attendee._id}`}
              onClose={() => setDialog('')}
              attendeeId={attendee._id}
            />
          </Col>
        ))}
      </Row>

      <div className="d-flex justify-content-center mt-5">
        <Button
          variant="primary"
          size="lg"
          type="button"
          className="ms-3"
          disabled={attendees.length === 0}
          style={{
            minWidth: '200px'
          }}
          onClick={() => setView('summary')}
        >
          Weiter
        </Button>
      </div>
    </>
  )
}

export default StepAttendees
